import React, { Fragment, useCallback, useContext, useState, useEffect, useRef } from "react";
import { Form, Row, Col, Button } from "antd";
import Select_v2 from "../../stories/components/Select_v2";
import { ServiceDetailsSelectArrow } from "../../stories/components/service_details_v2/ServiceDetailsV2";
import ReusableDatePicker from "../../stories/components/ReusableDatePicker";
import AppConfig from "../../config/AppConfig";
import Modal_v2 from "../../stories/components/Modal_v2";
import moment from "moment";
import AntDTimePicker from "./AntDTimePicker";
import PropTypes from "prop-types";
import { OrgContext } from "../../context/OrgContext";
import ErrorComponent from "../common/ErrorComponent";
import ClockTimeIcon from "../../common/CustomIcon";
import "./AppointmentWindow.scss";
import { isAppointmentMandatoryOrg } from "../../helpers/appointmentOrgConfig";
const AppointmentWindow = (props) => {
  const {
    labelCode,
    hideLabel,
    location,
    handleOnChange,
    availableDatesInfo,
    hasDeliveryZipcodesConfig,
    handleAppointmentTimeChange,
    options,
    gridSizes = {},
    MultiStopGridSizes = {},
    appointmentTime = "",
    multiStop,
    allowAppointment = false,
    keyToUse = "appointment",
    actionType,
    disableEditLHOrder=false,
    useV2Label = false,
    afterTimeCol = null,
    getFieldDecorator,
    form
  } = props;
  const { orgSettings, currentOrg } = useContext(OrgContext);
  const [customTimeModal, setCustomTimeModal] = useState(false);
  const [customTimeObj, setCustomTimeObj] = useState({});
  const isAutomaticTimeSlot = orgSettings?.automatic_time_slot_for_order == 'true';
  const automaticTimeFrame = _.toNumber(orgSettings?.automatic_time_frame_for_order) || 1;
  const [startTime, setStartTime] = useState(customTimeObj?.start_time || isAutomaticTimeSlot ? "" : moment());
  const [endTime, setEndTime] = useState(customTimeObj?.end_time || isAutomaticTimeSlot ? "" : moment().add(orgSettings.service_duration, "minute"));
  const [error, setError] = useState('');
  const isMilitaryTime = orgSettings.is_military_time == 'true';
  const timeFormat = isMilitaryTime ? "HH:mm" : "hh:mm A";
  const [forceUpdate, setForceUpdate] = useState(0);
  const [slotError, setSlotError] = useState([]);

  const seq = location?.loc_order_sequence ?? 0;
  const labelCodeVal = location?.label_code ?? 'appt';
  const dateFieldName = `${seq}_${labelCodeVal}_appt_date`;
  const timeFieldName = `${seq}_${labelCodeVal}_appt_time`;
  const isOrgSpecific = isAppointmentMandatoryOrg(currentOrg?.code);
  // Expedite always needs a date (any org, any setting) — Expedite is meaningless
  // without one. Appointment-mandatory is the prod org-gated rule (MWE/FET).
  const isRequired =
    !!location?.[keyToUse]?.has_expedite ||
    (isOrgSpecific && !!location?.[keyToUse]?.has_appointment);

  const firstRenderRef = useRef(true);
  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }
    // Preserving the selected values on unchecking/changing isRequired as per requirements.
    // antd v3 keeps a field's validation error after a failed submit even once its
    // `required` rule flips off — so unchecking Expedite/Appointment left stale
    // "... is required." messages (and a phantom block). Clear them when no longer required.
    if (!isRequired && form && form.setFields) {
      form.setFields({
        [dateFieldName]: { value: form.getFieldValue(dateFieldName), errors: undefined },
        [timeFieldName]: { value: form.getFieldValue(timeFieldName), errors: undefined },
      });
    }
  }, [isRequired]);

  const formatTime = (timeString, isMilitaryTime) => {
    const [startTime, endTime] = timeString.split(" - ");
    const formattedStartTime = moment(startTime, "HH:mm").format(isMilitaryTime ? "HH:mm" : "hh:mm A");
    const formattedEndTime = moment(endTime, "HH:mm").format(isMilitaryTime ? "HH:mm" : "hh:mm A");
    return `${formattedStartTime} - ${formattedEndTime}`;
  };
  const validateSlot = (value) => {
    if (!value) {
      handleAppointmentTimeChange(null);
      return;
    }
    if (value !== "custom_time") {
      handleAppointmentTimeChange(value)
    } else {
      handleAppointmentTimeChange(null);
      setCustomTimeModal(true)
    }
  }
  const confirmCustomTime = (startTime, endTime) => {
    const time = `${startTime}-${endTime}`;
    handleAppointmentTimeChange(time, {
      start_time: startTime,
      end_time: endTime
    },"custom_time");
    setCustomTimeModal(false);
  };
  const forceSelectUpdate = useCallback(() => {
    setForceUpdate((prev) => prev + 1);
  }, []);
  const customTimeModalFunction = (isRequired) => {
    const validateTimes = () => {
      const errors = [];
      // Check if start and end times are provided
      if (!startTime || !endTime) {
        setError('Both start and end times are required.');
        return false;
      }
      // Check if end time is after start time
      if (moment(endTime, timeFormat).isBefore(moment(startTime, timeFormat))) {
        setError('End time cannot be earlier than start time.');
        return false;
      }
      // Format times as strings and create new time slot
      const startTimeString = startTime.format("HH:mm");
      const endTimeString = endTime.format("HH:mm");
      const newTimeSlot = `${startTimeString}-${endTimeString}`;
      // Check if the new time slot already exists
      const existingOption = options.find(option => option.value === newTimeSlot);
        if (existingOption) {
         handleAppointmentTimeChange(existingOption.value);
         setCustomTimeModal(false);
        return false;
       }
      setSlotError(errors); // Update the slotError state with the array
      return errors.length === 0; // Return true if no errors
    };
    const confirmCustomTimeSolt = () => {
      if (validateTimes()) {
        const startTimeString = startTime.format("HH:mm") || null
        const endTimeString = endTime.format("HH:mm") || null
        confirmCustomTime(startTimeString, endTimeString);
        setCustomTimeModal(false);
      }
    };
    return (

      <Modal_v2
        visible={customTimeModal}
        onCancel={() => {
          setCustomTimeModal(false);
          forceSelectUpdate(); // Force update when modal is canceled
        }}
        destroyOnClose
        title="Custom Time Window"
        closable={false}
        content={
          <>
            <Row>
              <ErrorComponent errors={slotError} />
            </Row>
            <Row gutter={16} style={{ display: "flex", justifyContent: "space-between", height: "70px" ,width: "100%",maxWidth: "600px",margin: "0 auto" }}>
              <Col style={{ flex: 1, minWidth: "150px" }}>
                <Form.Item
                  className={`AppointmentWindow ${isMilitaryTime ? "AppointmentWindowWhenMilitarytime" : ""}`}
                  label={
                    <span>
                      Start Time <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  colon={false}
                  style={{ width: "100%" }}
                  key={`${location.label_code}_start_time`}
                  help={error && error.startsWith('Both') ? error : ''}
                  validateStatus={error && error.startsWith('Both') ? 'error' : ''}
                >
                  <AntDTimePicker
                    dataTestId="start-time-picker"
                    isMilitaryTime={isMilitaryTime}
                    placeholder={isMilitaryTime ? "HH:MM" : "HH:MM AA"}
                    style={{ width: "148px", }}
                    value={startTime}
                    disabled={isAutomaticTimeSlot ? true : false}
                    onChange={(formattedTime) => {
                      setStartTime(formattedTime);
                      if (formattedTime) {
                        setEndTime((prevEnd) => {
                          if (prevEnd && moment(prevEnd, timeFormat).isBefore(moment(formattedTime, timeFormat))) {
                            return null;
                          }
                          return prevEnd;
                        });
                      }
                    }}
                    computeDisabledHours={() => (endTime ? [] : [])}
                    computeDisabledMinutes={() => []}
                  />
                </Form.Item>
              </Col>
              <Col style={{ flex: 1, minWidth: "150px" }}>
                <Form.Item
                  className={`AppointmentWindow ${isMilitaryTime ? "AppointmentWindowWhenMilitarytime" : ""}`}
                  style={{ width: "100%" }}
                  label={
                    <span>
                      End Time <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  colon={false}
                  key={`${location.label_code}_end_time`}
                  help={error && error.startsWith('End') ? error : ''}
                  validateStatus={error && error.startsWith('End') ? 'error' : ''}
                >
                  <AntDTimePicker
                    dataTestId="end-time-picker"
                    placeholder={isMilitaryTime ? "HH:MM" : "HH:MM AA"}
                    isMilitaryTime={isMilitaryTime}
                    style={{ width: "148px" }}
                    value={endTime}
                    onChange={(formattedTime) => {
                      if (isAutomaticTimeSlot) {
                        const timeWithBuffer = moment(formattedTime, timeFormat).subtract(automaticTimeFrame || 1, 'hours');
                        setStartTime(timeWithBuffer);
                      }
                      setEndTime(formattedTime);
                      if (formattedTime && moment(formattedTime, timeFormat).isBefore(moment(startTime, timeFormat))) {
                        setError('End time cannot be earlier than start time.');
                      } else {
                        setError('');
                      }
                    }}
                    computeDisabledHours={() => (startTime ? [] : [])}
                    computeDisabledMinutes={() => []}
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        }
        width={360}
        footer={ // Custom Footer
          <div style={{ textAlign: "right" }}>
            <Button
              data-testid="cancel-button"
              type="link"
              className="button-2-large"
              onClick={() => {
                setCustomTimeModal(false);
                forceSelectUpdate();
              }}
            >
              Cancel
            </Button>
            <Button
              data-testid="add-time-button"
              type="link"
              className="button-2-large"
              onClick={confirmCustomTimeSolt}
            >
              Add Time
            </Button>
          </div>
        }
      />
    );
  };

  const renderDateTime = () => {
    const isDateMissing = (location?.[keyToUse]?.has_appointment || location?.[keyToUse]?.has_expedite) && !location?.[keyToUse]?.appt_date;
    const isTimeMissing = (location?.[keyToUse]?.has_appointment || location?.[keyToUse]?.has_expedite) && (!location?.[keyToUse]?.start_time || !location?.[keyToUse]?.end_time);

    const datePickerNode = (
              <ReusableDatePicker
                data-testid="appointment-date-picker"
                placeholder={AppConfig.dateFormat}
                format={AppConfig.dateFormat}
                value={
                  location?.[keyToUse]?.appt_date
                    ? moment(location[keyToUse].appt_date)
                    : null
                }
                onChange={(date) => {
          handleOnChange("appt_date", keyToUse, date);
          if (form && form.setFieldsValue) {
            form.setFieldsValue({ [dateFieldName]: date });
          }
        }}
                dateRender={(current) => {
                  const style = {};
                  const pickerDate = current.format("YYYY-MM-DD");
                  if (
                    hasDeliveryZipcodesConfig &&
                    availableDatesInfo?.feasible_dates?.includes(pickerDate)
                  ) {
                    style.border = "2px solid green";
                    style.borderRadius = "50%";
                    style.fontSize = "11px";
                  }
                  return (
                    <div className="ant-calendar-date fontSize12" style={style}>
                      {current.date()}
                    </div>
                  );
                }}
                defaultValue={null}
                onOk={() => { }}
                disabledDate={(current) =>
                  !props.isCreateOrder && current &&
                  current <=
                  moment(
                    moment().add(AppConfig.orderFieldDuration - 24, "hours"),
                    "YYYY-MM-DD"
                  )
                }
                disabled={disableEditLHOrder || allowAppointment }
              />
    );

    const timeSelectNode = (
      <Select_v2
        data-testid="appointment-time-dropdown"
        labelField="label"
        valueField="value"
        options={options.map(option => ({
          ...option,
          label: option.value === "custom_time"
            ? option.label
            : formatTime(option.label, isMilitaryTime)
        }))}
        value={appointmentTime}
        onChange={(val) => {
          validateSlot(val);
          if (form && form.setFieldsValue) {
            form.setFieldsValue({ [timeFieldName]: val });
          }
        }}
        key={forceUpdate}
        disabled={ disableEditLHOrder || props.allowAppointment}
        allowClear
        dropdownMatchSelectWidth={false}
        suffixIcon={useV2Label ? <ServiceDetailsSelectArrow /> : undefined}
      />
    );

    return (
      <>
      <div style={multiStop === "MS" ? (props.appointmentStyle ? { position: "relative", bottom: "5px" } : {}) : {}}>
        <Col span={multiStop === "MS" ? 6 : 12} {...(multiStop === "MS" ? MultiStopGridSizes : gridSizes)} className="table-col">
            <Form.Item
              label={(hideLabel || useV2Label) ? null : labelCode}
              required={isRequired}
              name="appointment_date"
              className={`${isRequired ? "required-star-right" : ""} custom-form-item`}
              validateStatus={getFieldDecorator ? undefined : (isDateMissing ? "error" : undefined)}
              help={getFieldDecorator ? undefined : (isDateMissing ? `${labelCode} is required.` : undefined)}
            >
              {/* service_levels v2 header: custom label chip when useV2Label,
                  in place of the antd label hidden above. */}
              {useV2Label && (
                <div
                  className="RefNumbersStyle"
                  style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between" }}
                >
                  <span className="sdv2-label">{labelCode}{isRequired && <span style={{ color: "red", marginLeft: 2 }}>*</span>}</span>
                </div>
              )}
              {getFieldDecorator ? getFieldDecorator(dateFieldName, {
                rules: [
                  {
                    required: isRequired,
                    message: `${labelCode} is required.`,
                  },
                ],
                initialValue: location?.[keyToUse]?.appt_date ? moment(location[keyToUse].appt_date) : null,
              })(datePickerNode) : datePickerNode}
            </Form.Item>
        </Col>
        <Col
          span={multiStop === "MS" ? 6 : 12} {...(multiStop === "MS" ? MultiStopGridSizes : gridSizes)}
          className={`table-col-address down-adjustment ${actionType === 'view' ? 'time-adjustment' : ''}`}
          style={{ paddingLeft: actionType === 'view' ? 0 : 12 }}
        >
          <Form.Item
            name="appointment_time"
            key={`${location.label_code}_appointment_time`}
            className="custom-form-item"
            style={{ marginTop: 0 }}
            validateStatus={getFieldDecorator ? undefined : (isTimeMissing ? "error" : undefined)}
            help={getFieldDecorator ? undefined : (isTimeMissing ? "Time Window Slot is required." : undefined)}
          >
            {getFieldDecorator ? getFieldDecorator(timeFieldName, {
              rules: [
                {
                  required: isRequired,
                  message: "Time Window Slot is required.",
                },
              ],
              initialValue: appointmentTime || undefined,
            })(timeSelectNode) : timeSelectNode}
          </Form.Item>
        </Col>
        {afterTimeCol}
        </div>
      </>
    );
  };

  return (
    <Fragment>
      {multiStop !== "MS" ? (
        <Row gutter={[24, 0]} align="bottom" className={multiStop === "MS" ? "" : "marginTop8"}>
          {renderDateTime()}
        </Row>
      ) :
        renderDateTime()
      }
      {customTimeModal && customTimeModalFunction()}
    </Fragment>
  );
};
AppointmentWindow.propTypes = {
  currentPreplan: PropTypes.shape(),
  setOutofPreplan: PropTypes.func,
  setIsModified: PropTypes.func,
};
AppointmentWindow.defaultProps = {
  currentPreplan: {},
  setOutofPreplan: () => { },
  setIsModified: () => { },
};
export default AppointmentWindow;